import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { gridColumns_PastPaymentsToLender } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";

import urls from "../../Utils/urls";
import axios from "../../axios";
import { useAbortController } from "../../hooks/useAbortController";

const PastPaymentsToLenderTable = ({ tHeight = "30vh", className, loanId }) => {
  const [trustLedgerReserve, setTrustLedgerReserve] = useState(null);
  const accountId = useSelector((state) => state.account.lenderId);
  const { signal } = useAbortController();

  useEffect(() => {
    setTrustLedgerReserve(null);
    const fetchData = async () => {
      const res = await axios.get(
        urls.dashboard.getPastPaymentsloantolender(loanId, accountId),
        { signal }
      );
      let data = res?.data?.[0] || [];
      const newdata = data?.map((item) => ({
        ...item,
        Principal: item["Principal"].replace("$", "").replace(",", ""),
        Interest: item["Interest"].replace("$", "").replace(",", ""),
        ["Late Charge"]: item["Late Charge"].replace("$", "").replace(",", ""),
        ["Servicing Fee"]: item["Servicing Fee"]
          .replace("$", "")
          .replace(",", ""),
        ["Other"]: item["Other"].replace("$", "").replace(",", ""),
        ["Amount"]: item["Amount"].replace("$", "").replace(",", ""),
      }));
      setTrustLedgerReserve(newdata);
    };
    fetchData();
  }, [accountId]);

  return (
    <>
      {trustLedgerReserve ? (
        <CommonGrid
          className={`col-sm-12 ${className}`}
          title={"Past Payments to Lender"}
          gridColumns={gridColumns_PastPaymentsToLender}
          columnData={trustLedgerReserve}
          tableTotal={[
            "Principal",
            "Interest",
            "Servicing Fee",
            "Late Charge",
            "Other",
            "Amount",
          ]}
          // tHeight={tHeight}
        />
      ) : (
        <SpinnerBlock />
      )}
    </>
  );
};

export default PastPaymentsToLenderTable;
